import apiClient from '@/lib/api';

export type BackofficeRole = 'super_admin' | 'viewer' | 'internal_viewer';

/** Roles that can be handed out from the invite dialog. */
export type InvitableRole = Extract<BackofficeRole, 'viewer' | 'internal_viewer'>;

export interface TeamMemberRecord {
  id: string; // user publicId for active members, invitation id for pending
  name: string;
  email: string;
  role: BackofficeRole;
  avatar: string;
  status: 'active' | 'pending';
  isInvitation?: boolean;
}

export const teamService = {
  getTeam: async (): Promise<TeamMemberRecord[]> => {
    const response = await apiClient.get<{ data: TeamMemberRecord[] }>('/admin/team');
    return response.data.data;
  },

  invite: async (email: string, role: InvitableRole): Promise<void> => {
    await apiClient.post('/admin/team/invite', { email, role });
  },

  updateRole: async (id: string, role: InvitableRole): Promise<void> => {
    await apiClient.patch(`/admin/team/${id}`, { role });
  },

  resendInvite: async (invitationId: string): Promise<void> => {
    await apiClient.post(`/admin/team/${invitationId}/resend-invite`);
  },

  remove: async (id: string): Promise<void> => {
    await apiClient.delete(`/admin/team/${id}`);
  },
};
